{
  "A summary of the practice's history for scheduling.": "A summary of the practice's history for scheduling.",
  "AI Receptionist": "AI Receptionist",
  "AI-Added": "AI-Added",
  "Activity Date": "Activity Date",
  "Applied Filters ({{count}})_one": "Applied Filters ({{count}})",
  "Applied Filters ({{count}})_other": "Applied Filters ({{count}})",
  "Apply": "Apply",
  "Appointment Time": "Appointment Time",
  "Appointment Type": "Appointment Type",
  "By {{actorUserName}}": "By {{actorUserName}}",
  "Calendar": "Calendar",
  "Cancellation": "Cancellation",
  "Current Status": "Current Status",
  "Direct Booked": "Direct Booked",
  "End: {{date}}": "End: {{date}}",
  "Event": "Event",
  "Filters": "Filters",
  "Office Added": "Office Added",
  "Other": "Other",
  "Patient": "Patient",
  "Patient Added": "Patient Added",
  "Refresh Data": "Refresh Data",
  "Request": "Request",
  "Rescheduled": "Rescheduled",
  "Reset": "Reset",
  "Schedule Activity": "Schedule Activity",
  "Schedule an appointment to begin building your practice history.": "Schedule an appointment to begin building your practice history.",
  "Scheduled": "Scheduled",
  "Self Added": "Self Added",
  "Service": "Service",
  "Source": "Source",
  "Staff Added": "Staff Added",
  "Start: {{date}}": "Start: {{date}}",
  "Status": "Status",
  "Time": "Time",
  "Time Frame": "Time Frame",
  "Via Partner": "Via Partner",
  "Via Schedule Request": "Via Schedule Request",
  "Via Waitlist": "Via Waitlist",
  "Via online scheduling": "Via online scheduling",
  "Your schedule activity is empty": "Your schedule activity is empty",
  "by Staff": "by Staff",
  "via AI Receptionist": "via AI Receptionist",
  "via Online Scheduling": "via Online Scheduling",
  "via PMS": "via PMS",
  "via Waitlist": "via Waitlist"
}
